export const EVENTS_TRANSACTION = 'EVENTS_TRANSACTION'
export const EVENTS_BATCH = 'EVENTS_BATCH'
